import { render, staticRenderFns } from "./ListaProductos.vue?vue&type=template&id=143bf180&lang=pug&"
import script from "./ListaProductos.vue?vue&type=script&lang=js&"
export * from "./ListaProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports